export const SKU_ANALYTICS_EVENTS = Object.freeze({
  CATEGORY_AVAILABILITY_CHANGED: 'SKU Category Availability Changed',
  CATEGORY_CREATED: 'SKU Category Created',
  CATEGORY_DELETED: 'SKU Category Deleted',
  CATEGORY_DUPLICATED: 'SKU Category Duplicated',
  CATEGORY_EDITED: 'SKU Category Edited',
  CATEGORY_ITEM_ADDED: 'SKU Category Item Added',
  CATEGORY_ITEM_REMOVED: 'SKU Category Item Removed',
  ITEM_AVAILABILITY_CHANGED: 'SKU Item Availability Changed',
  ITEM_CREATED: 'SKU Item Created',
  ITEM_DELETED: 'SKU Item Deleted',
  ITEM_EDITED: 'SKU Item Edited',
  ITEM_MARKED_OUT_OF_STOCK: 'Item Marked Out of Stock',
  ITEM_MENU_OPENED: 'Item Menu Opened',
  MENU_AVAILABILITY_CHANGED: 'SKU Menu Availability Changed',
  MENU_CREATED: 'SKU Menu Created',
  MENU_UPDATED: 'SKU Menu Updated',
  MODIFIER_GROUP_AVAILABILITY_CHANGED: 'SKU Modifier Group Availability Changed',
  MODIFIER_GROUP_CREATED: 'SKU Modifier Group Created',
  MODIFIER_GROUP_DELETED: 'SKU Modifier Group Deleted',
  MODIFIER_GROUP_DUPLICATED: 'SKU Modifier Group Duplicated',
  MODIFIER_GROUP_EDITED: 'SKU Modifier Group Edited',
  MODIFIER_GROUP_EDITOR_OPENED: 'SKU Modifier Group Editor Opened',
  MODIFIER_GROUP_ITEM_ADDED: 'SKU Modifier Group Item Added',
  MODIFIER_GROUP_ITEM_REMOVED: 'SKU Modifier Group Item Removed',
  MODIFIER_GROUP_REORDERED: 'SKU Modifier Group Reordered',
  ORDER_CANCELLED: 'Order Cancelled',
  ORDER_FLYOUT_OPENED: 'Order Flyout Opened',
  ORDER_HISTORY_VIEWED: 'Order History Viewed',
  ORDER_MANAGEMENT_PAGE_OPENED: 'Order Management Page Opened',
  ORDER_MARKED_AS_FULFILLED: 'Order Marked as Fulfilled',
  USER_CONTACTED: 'User Contacted',
  USER_MARKED_AS_MISSED_PICKUP: 'User Marked as Missed Pickup',
  VENUE_CLOSED_FOR_DAY: 'SKU Venue Closed for Day',
  VENUE_OPENED: 'SKU Venue Opened for Day',
});

export const SKU_ORDER_ACTION_SURFACE = Object.freeze({
  ACTIVE_ORDER_MENU: 'active_order_menu',
  ORDER_FLYOUT: 'order_flyout',
});
